@if (ShowLogin) {
  <div id="loginModal" class="modal" [ngStyle]="{ 'z-index': 1001, display: 'block' }">
    <!-- Modal content -->
    <div class="modal-content">
      <div class="modal-header" [ngStyle]="{
                      'justify-content': 'right',
                      height: '40px',
                      backgroundColor:
                        (Merchant$ | async)?.webapp_settings?.menu_color ||
                        (Merchant$ | async)?.menu_color,
          'border-bottom': borderStyle,
        }"
      >
        <a (click)="closeLogin()" id="btnnotification" class="close-icon">
          <i [ngStyle]="{
                        color: menuBorderColor,
            }"
            class="zmdi zmdi-close zmdi-hc-fw"
          ></i>
        </a>
      </div>
      <div class="d-flex flex-column" [ngStyle]="{
                      backgroundColor:
                        (Merchant$ | async)?.webapp_settings?.homepage_bottom_color ||
                        (Merchant$ | async)?.menu_color,
        }"
      >
        <section
          class="page-content d-flex align-items-center justify-content-center flex-fill"
        >
          <div class="login-box">
            <div class="login-box-body">
              <form #LoginForm="ngForm" (ngSubmit)="attemplogin(LoginForm)" novalidate>
                <!-- <div class="d-grid mb-4">
                        @if ((Merchant$ | async)?.webapp_settings?.guest_access_allowed) {
                        <button type="button" (click)="Guestlogin(true)" class="btn btn-lg "
                            [ngStyle]="{'backgroundColor' : (Merchant$ | async)?.webapp_settings?.menu_color || (Merchant$ | async)?.menu_color,'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae || (Merchant$ | async)?.menu_font_color_homepgae, 'border' :borderStyle }">Proceed
                            as guest</button>
                        }
                    </div> -->
                <div class="form-group">
                  <label
                    [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                    }"
                    >Email address
                    <i class="zmdi zmdi-help-outline" (click)="LoginInfo()"></i>
                  </label>
                  <input
                    type="text"
                    id="username"
                    name="txtusername"
                    ngModel
                    required
                    class="form-control form-control-lg"
                    placeholder="Email ID"
                  />

                  @if (
                  LoginForm?.controls["txtusername"]?.invalid &&
                  (LoginForm?.controls["txtusername"].dirty ||
                  LoginForm?.controls["txtusername"].touched)
                  ) {
                  <div>
                    @if (LoginForm?.controls["txtusername"].errors.required) {
                    <span
                          [ngStyle]="{
                            color:
                              (Merchant$ | async)?.webapp_settings
                                ?.menu_font_color_homepgae ||
                              (Merchant$ | async)?.menu_font_color_homepgae,
                          }"
                        >
                          please fill Email address.
                        </span>
                      }
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label
                    [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                    }"
                    >Password</label
                  >
                  <input
                    type="password"
                    name="txtpassword"
                    id="password"
                    ngModel
                    required
                    class="form-control form-control-lg"
                    placeholder="Password"
                  />
                  @if (
                    LoginForm.controls["txtpassword"]?.invalid &&
                    (LoginForm.controls["txtpassword"].dirty ||
                      LoginForm.controls["txtpassword"].touched)
                  ) {
                    <div>
                      @if (LoginForm.controls["txtpassword"].errors.required) {
                      <span
                          [ngStyle]="{
                            color:
                              (Merchant$ | async)?.webapp_settings
                                ?.menu_font_color_homepgae ||
                              (Merchant$ | async)?.menu_font_color_homepgae,
                          }"
                        >
                          please fill Password.
                        </span>
                      }
                    </div>
                  }
                </div>
                <div class="d-grid">
                  <button type="submit" id="btnlogin" (ngSubmit)="attemplogin(LoginForm)" class="btn btn-lg mt-4" [ngStyle]="{
                                                          backgroundColor:
                                                            (Merchant$ | async)?.webapp_settings?.menu_color ||
                                                            (Merchant$ | async)?.menu_color,
                                                          color:
                                                            (Merchant$ | async)?.webapp_settings
                                                              ?.menu_font_color_homepgae ||
                                                            (Merchant$ | async)?.menu_font_color_homepgae,
                      border: borderStyle,
                    }"
                  >
                    Sign In
                  </button>
                </div>
              </form>
            </div>
            <div class="login-box-footer clearfix text-center">
              <!-- <div class="sign-up-link mt-2">
                    <a routerLink="/Registertion" class="btn btn-md mt-2"
                        [ngStyle]="{'backgroundColor' : (Merchant$ | async)?.webapp_settings?.menu_color || (Merchant$ | async)?.menu_color,'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae || (Merchant$ | async)?.menu_font_color_homepgae,'width': '50%', 'border' :borderStyle }">
                        Register</a>
                </div> -->

              <!-- <div class="sign-up-link mt-2">
                    <button class="btn btn-md mt-2" (click)="SkipLogin()"
                        [ngStyle]="{'backgroundColor' : (Merchant$ | async)?.webapp_settings?.menu_color || (Merchant$ | async)?.menu_color,'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae || (Merchant$ | async)?.menu_font_color_homepgae,'width': '100%', 'border' :borderStyle }">
                        Skip this for now</button>
                </div> -->

              <div class="password-reset-link mt-2">
                <a [href]="pageModel.APIServer + '/password/reset'" class="btn btn-lg mt-2" [ngStyle]="{
                                    backgroundColor:
                                      (Merchant$ | async)?.webapp_settings?.menu_color ||
                                      (Merchant$ | async)?.menu_color,
                                    color:
                                      (Merchant$ | async)?.webapp_settings
                                        ?.menu_font_color_homepgae ||
                                      (Merchant$ | async)?.menu_font_color_homepgae,
                                    width: '100%',
                    border: borderStyle,
                  }"
                >
                  Reset Password?</a
                >
              </div>

              <div class="text-center mt-2" [ngStyle]="{
                                              color:
                                                (Merchant$ | async)?.webapp_settings
                                                  ?.menu_font_color_homepgae ||
                                                (Merchant$ | async)?.menu_font_color_homepgae,
                }"
              >
                by continuing you agree to our<br />Terms and Privacy Policy
              </div>
            </div>
          </div>
        </section>

        <!-- Getting Guest user details as per the webapp setting flag if flag on then it will required -->

        <app-guestlogin [currentMerchant]="currentMerchant" (GuestLoginChange)="Guestlogin($event)"
          [GuestLogin]="GuestLogin"></app-guestlogin>
        </div>
        </div>
        </div>
}
<ng-template #errorinfo let-model>
  <!-- Modal content -->
  <div class="modal-header" [ngStyle]="{
      backgroundColor:
        (Merchant$ | async)?.webapp_settings?.menu_color ||
        (Merchant$ | async)?.menu_color,
      'border-bottom': borderStyle,
    }"
  >
    <h3
      class="w-100"
      [ngStyle]="{
        color:
          (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
          (Merchant$ | async)?.menu_font_color_homepgae,
        'text-align': 'center',
      }"
      id="storename"
    >
      {{ (Merchant$ | async)?.name }}
    </h3>
  </div>
  <div class="modal-body">
    <p [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
      }"
      id="textcontent"
    >
      @if (!pageModel.isInfoPopup) {
        <span>Register and/or sign in to avail relevant discounts & promotions, or,
          if option available, proceed as guest only.</span>
        }
        @if (pageModel.isInfoPopup) {
        <span>If you have previously registered with one of our toodle powered Apps
          or if you have a toodle marketplace App account you may use the same
          login credentials here. If you have forgotten your password click the
          Reset Password’ button below and a reset link will be sent to your
          registered email address.</span>
          }
          </p>
          </div>
          @if (!pageModel.isInfoPopup) {
    <div class="modal-footer justify-content-center">
      <button id="btnclosepop" [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          border: borderStyle,
        }"
        (click)="model.close()"
      >
        CONTINUE
      </button>
    </div>
  }
  @if (pageModel.isInfoPopup) {
    <div class="modal-footer">
      <button id="btnclose" [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          border: borderStyle,
        }"
        (click)="model.close()"
      >
        Cancel
      </button>
    </div>
  }
</ng-template>

<ng-template #basketinfo let-model>
  <!-- Modal content -->
  <div class="modal-header" [ngStyle]="{
      backgroundColor:
        (Merchant$ | async)?.webapp_settings?.menu_color ||
        (Merchant$ | async)?.menu_color,
      'border-bottom': borderStyle,
    }"
  >
    <h3
      class="w-100"
      [ngStyle]="{
        color:
          (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
          (Merchant$ | async)?.menu_font_color_homepgae,
        'text-align': 'center',
      }"
      id="storename"
    >
      {{ (Merchant$ | async)?.name }}
    </h3>
  </div>
  <div class="modal-body">
    <p [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
      }"
      id="textcontent"
    >
      <span>
        <p [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_allpage,
          }"
          id="textcontent"
        >
          <span>You have items waiting in your basket!</span>
        </p>
      </span>
      </p>
    <p [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
      }"
      id="textcontent"
    >
      <span
        >It looks like you added some products to your basket during your
        previous session but didn’t complete the checkout. Would you like to
        retrieve them and continue shopping?</span>
    </p>
  </div>
  <div class="modal-footer" [ngStyle]="{ display: 'block' }">
    <div class="d-grid">
      <button type="button" [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          border: borderStyle,
        }"
        class="btn btn-accent-theme btn-lg mt-2"
        (click)="retrieveBasket(); model.close()"
      >
        Proceed
      </button>

      <button type="button" [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          border: borderStyle,
        }"
        class="btn btn-accent-theme btn-lg mt-2"
        (click)="model.close()"
      >
        Cancel
      </button>
    </div>
  </div>
  <!-- <div class="modal-footer">
        <button id="btnclose"
            [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae || (Merchant$ | async)?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
            (click)="model.close();"> Cancel</button>
    </div> -->
</ng-template>
<ng-template #locationinfo let-model>
  <!-- Modal content -->
  <div class="modal-header" [ngStyle]="{
      backgroundColor:
        (Merchant$ | async)?.webapp_settings?.menu_color ||
        (Merchant$ | async)?.menu_color,
      'border-bottom': borderStyle,
    }"
  >
    <span
      class="w-100"
      [ngStyle]="{
        color:
          (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
          (Merchant$ | async)?.menu_font_color_homepgae,
        'text-align': 'center',
      }"
      id="storename"
      >{{ (Merchant$ | async)?.name }}</span
    >
  </div>
  <div class="modal-body">
    <p [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
      }"
      id="textcontent"
    >
      <span>
        <p [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_allpage,
          }"
          id="textcontent"
        >
          <span>Welcome Back!</span>
        </p>
      </span>
      </p>
    <p [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
      }"
      id="textcontent"
    >
      <span
        >Your last selected location was:

        {{ selectedLocationData?.table?.name }}
      </span>
      @if (selectedLocationData && selectedLocationData.address) {
      <span>
        Location: {{ selectedLocationData.address?.name }}
        {{ selectedLocationData.address?.line_1 }}
        </span>
      }
      </p>
      </div>
      <div class="modal-footer" [ngStyle]="{ display: 'block' }">
    <div class="d-grid">
      <button type="button" [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          border: borderStyle,
        }"
        class="btn btn-accent-theme btn-lg mt-2"
        (click)="retrieveBasket(); model.close()"
      >
        Proceed
      </button>

      <button type="button" [ngStyle]="{
                      color:
                        (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
                        (Merchant$ | async)?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          border: borderStyle,
        }"
        class="btn btn-accent-theme btn-lg mt-2"
        (click)="model.close()"
      >
        Change Location
      </button>
    </div>
  </div>
  <!-- <div class="modal-footer">
        <button id="btnclose"
            [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae || (Merchant$ | async)?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
            (click)="model.close();"> Cancel</button>
    </div> -->
</ng-template>

<div id="commonFulfillmentModal1" class="modal checkout-modal" data-backdrop="static">
  <app-select-location (popupClose)="closeSelectLocation()" (OpenAddress)="OpenAddressModel()"
    [selectedAddress]="selectedLocation" [selectedTable]="selectedTable" [isSelectedLocation]="isFromLogin">
  </app-select-location>
</div>

<div id="AddressModal" class="modal checkout-modal">
  <app-Pin-Address (cancel)="cancel()" (Message)="AlertBox($event)">
  </app-Pin-Address>
</div>
